import { Search } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  styled,
} from "@mui/material";
import { Field, useFormikContext } from "formik";
import { TextField } from "formik-mui";

import { useTranslation } from "react-i18next";

import { LayerSearchFormValues } from "../../../types";

interface Props {
  className?: string;
}

export function LayerSearchQueryField(props: Props) {
  const { className } = props;
  const { t } = useTranslation();
  const { values } = useFormikContext<LayerSearchFormValues>();

  return (
    <Styles className={className}>
      {!values.layer && (
        <FormControl fullWidth className="placeholder-label" variant="standard">
          <InputLabel>{t("label.pleaseSelectALayer")}</InputLabel>
        </FormControl>
      )}
      {values.layer && values.attributes.length < 1 && (
        <FormControl fullWidth className="placeholder-label" variant="standard">
          <InputLabel>{t("label.pleaseSelectAttributes")}</InputLabel>
        </FormControl>
      )}
      {values.layer && values.attributes.length > 0 && (
        <Field
          component={TextField}
          id="query"
          name="query"
          variant="standard"
          fullWidth={true}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="submit">
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
          label={t("label.searchQuery")}
        ></Field>
      )}
    </Styles>
  );
}

const Styles = styled("div")`
  .MuiSelect-multiple {
    color: ${({ theme }) => theme.palette.common.white};

    .MuiCheckbox-root {
      display: none;
    }
    .MuiListItemText-root {
      display: inline-block;
    }
  }
`;
